import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Contacts () {

    return (

        <section id="contacts" className="block contacts-block">
            <div className='title-holder'>
                <h2>Contact information</h2>
            </div>
            <Container fluid>
                <Row>
                    <Col xs={6}>
                        
                    </Col>
                    <Col xs={6}>
                        <Form>
                            <Row className="mb-3">
                                <Col>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control placeholder="John" />
                                </Col>
                                <Col>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control placeholder="Doe" />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                <Form.Label>Email Adress</Form.Label>
                                <Form.Control placeholder="yourname@gmail.com" />
                                </Col>
                                <Col>
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control placeholder="09123456789" />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                <Form.Label>Message</Form.Label>
                                <Form.Control placeholder="Input your message here :)" as="textarea" rows={3} />
                                </Col>
                            </Row>

                            <Button variant="success" type="submit">
                                Submit
                            </Button>
                        </Form>
                    </Col>
                </Row>  
            </Container>
            
        </section>
    )

}

export default Contacts;